module.exports = __webpack_public_path__ + "img/person-badge-fill.3ed7f49c.svg";